import { Elm } from './generated/elm.js'
import '../styles/main.css'

// Same build-time substitution as the storefront; see ADR-0006.
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'

// The admin token is kept in sessionStorage rather than localStorage: it is
// scoped to the tab and cleared when the tab closes, which suits a back office
// on a shared machine. Reading it can throw in a locked-down browser.
let token = null
try {
  token = sessionStorage.getItem('sarsilver.admin.token')
} catch (_) {
  token = null
}

const app = Elm.Main.init({
  node: document.getElementById('app'),
  flags: { apiBaseUrl, token }
})

app.ports.persistToken.subscribe((value) => {
  try {
    if (value === null) {
      sessionStorage.removeItem('sarsilver.admin.token')
    } else {
      sessionStorage.setItem('sarsilver.admin.token', value)
    }
  } catch (_) {
    // Storage unavailable: the session simply does not survive a reload.
  }
})
